import React from 'react'
import { Box } from 'components/layout/Box/Box'
import styles from './Competency.module.scss'
import { CompetencyCard } from 'components/common/CompetencyCard/CompetencyCard'
import { interweave } from 'helpers'

export const CompetencyCards = ({
  data,
  getTraitScores,
  explanations,
  getScoreLabel,
  scores,
  language,
  onTab,
  isJobSeeker,
}) => {
  return (
    <Box className={styles.competencyCards}>
      {React.Children.toArray(
        interweave(
          data.map((card, index) => (
            <CompetencyCard
              isSingle={data.length === 1}
              trait={card}
              traitScores={[{ scores: getTraitScores(index, scores) }]}
              explanation={explanations[index]}
              scoreLabel={getScoreLabel(data, index)}
              isGreen={index % 2 === 1}
              language={language}
              onTab={onTab}
              isJobSeeker={isJobSeeker}
            />
          )),
          <div className={styles.divider} />,
        ),
      )}
    </Box>
  )
}
